import { memo, useMemo, useState } from "react";
import Slider, { Settings } from "react-slick";
import clsx from "clsx";
import ProductImage from "./ProductImage";

export const ProductGallery = memo(({ images }: { images: string[] }) => {
  const [nav1, setNav1] = useState<Slider | null>(null);
  const [nav2, setNav2] = useState<Slider | null>(null);

  const mainSettings: Settings = useMemo(
    () => ({
      asNavFor: nav2 as Slider,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: images.length > 1,
    }),
    [nav2, images.length],
  );

  const thumbSettings: Settings = useMemo(
    () => ({
      asNavFor: nav1 as Slider,
      slidesToShow: Math.min(images.length, 3),
      swipeToSlide: true,
      focusOnSelect: true,
      centerMode: true,
      centerPadding: "0px",
      arrows: false,
      infinite: images.length > 1,
    }),
    [nav1, images.length],
  );

  return (
    <div className="relative w-full md:w-3/5 lg:w-3/5 md:py-10">
      <Slider {...mainSettings} ref={setNav1}>
        {images.map((image) => (
          <div
            key={image}
            className="flex justify-center items-center !rounded-xl"
          >
            <div className="relative w-full h-96 !rounded-xl">
              <ProductImage
                src={image}
                alt="Product Image"
                className="!rounded-xl"
              />
            </div>
          </div>
        ))}
      </Slider>

      {images.length > 1 && (
        <div className="absolute z-10 w-full bottom-0 left-0 flex justify-center lg:-bottom-6">
          <div
            className="transition-all rounded-full shadow-xl backdrop-blur-md overflow-hidden lg:rounded-2xl pl-4"
            style={{
              width: `calc(${images.length * 80}px + ${(images.length + 1) * 8}px)`,
            }}
          >
            <Slider {...thumbSettings} ref={setNav2}>
              {images.map((image, i) => (
                <div
                  key={image}
                  className="flex justify-center items-center h-auto w-20"
                >
                  <div className="relative h-20 w-20 flex justify-center items-center">
                    <ProductImage
                      src={image}
                      alt="Thumbnail Image"
                      className={clsx(
                        "aspect-square my-1 mx-2",
                        i === 0 && "ml-2",
                      )}
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
});
